import axios from 'axios'
import { DRIVEPOINTS_BACKEND_URL } from 'utils/valhalla'

const getApiBaseUrl = () => {
  const base = (DRIVEPOINTS_BACKEND_URL || '').replace(/\/+$/, '')
  if (!base) {
    return '/v1'
  }
  return base.endsWith('/v1') ? base : `${base}/v1`
}

const getAuthHeaders = (auth) => ({
  Authorization: `Bearer ${auth?.user?.access_token}`,
  'Content-Type': 'application/json',
})

const unwrapApiResponse = (data) => {
  if (data && data.ok && data.data !== undefined) {
    return data.data
  }
  return data
}

const normalizeApiError = (error, fallbackMessage) => {
  const responseError = error?.response?.data
  return {
    status: error?.response?.status,
    code: responseError?.code || null,
    userStatus: responseError?.userStatus || null,
    message: responseError?.error || fallbackMessage,
  }
}

export const fetchMeContext = async (auth) => {
  try {
    const response = await axios.get(`${getApiBaseUrl()}/me`, {
      headers: getAuthHeaders(auth),
    })
    const data = unwrapApiResponse(response.data) || {}

    // Backward compatibility during UI-first rollout:
    // if /me does not return account lifecycle fields yet, treat as approved USER.
    const hasUserStatus =
      data.userStatus !== undefined &&
      data.userStatus !== null &&
      data.userStatus !== ''

    return {
      ...data,
      userStatus: hasUserStatus ? data.userStatus : 'APPROVED',
      globalRole: data.globalRole || 'USER',
    }
  } catch (error) {
    throw normalizeApiError(error, 'Failed to load account context')
  }
}

export const fetchAdminUsers = async (auth, params = {}) => {
  try {
    const response = await axios.get(`${getApiBaseUrl()}/admin/users`, {
      headers: getAuthHeaders(auth),
      params,
    })
    return unwrapApiResponse(response.data)
  } catch (error) {
    throw normalizeApiError(error, 'Failed to load users')
  }
}

export const patchAdminUser = async (auth, userId, payload) => {
  try {
    const response = await axios.patch(
      `${getApiBaseUrl()}/admin/users/${userId}`,
      payload,
      {
        headers: getAuthHeaders(auth),
      }
    )
    return unwrapApiResponse(response.data)
  } catch (error) {
    throw normalizeApiError(error, 'Failed to update user')
  }
}
